import { render } from "./AssetTypePage.vue?vue&type=template&id=480573c3"
import script from "./AssetTypePage.vue?vue&type=script&lang=js"
export * from "./AssetTypePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__